<template>
  <div :class="{'content-input':enableClassBase}" :id="identity">
    <input
      v-model="text"
      @keydown="writedown($event)"
      @keyup="writeup($event)"
      @focus="onFocus()"
      class="input-txt"
      :class="inputClass"
      type="text"
      :required="isRequired"
      :placeholder="placeholder"
    />

    <ul class="ui-autocomplete" :class="{active:text!='' && is_show}">
      <div v-if="text!='' && is_show" class="show-result">
        <li :key="idx" v-for="(dato,idx) of onSiteContacts" class="ui-menu-item item-found">
          <a @click="onSelectItem(dato)" class="ui-item-result person" tabindex="-1">
            <div class="info-container">
              <div style="max-width: 150px;">
                <span class="name">{{dato.contactName}}</span>
                <div class="info-group">
                  <span v-if="dato.contactPhone!=undefined" class="phone">
                    <span v-if="dato.contactPhone">{{dato.contactPhone}}</span>
                    <span v-else>N/A</span>
                  </span>
                  <span v-if="dato.contactEmail!=undefined" class="email">{{dato.contactEmail}}</span>
                     <span v-else>N/A</span>
                </div>
              </div>
            </div>
            <div></div>
          </a>
        </li>
      </div>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'on-site-contact-search',
  props: {
    placeholder: String,
    initialText: String,
    isRequired: {
      type: Boolean,
      default: false
    },
    enableClassBase: {
      type: Boolean,
      default: true
    },
    inputClass: Object,
    identity: {
      type: String,
      default: 'input-box'
    },
    onSiteContacts: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      text: '',
      is_show: true,
      typingTimer: null,
      doneTypingInterval: 300,
      is_read_initial_tex: false
    };
  },
  mounted () {
    console.log('The one that got the ')
    document.addEventListener('click', evt => {
      let flyoutElement = document.getElementById(this.identity);
      let targetElement = evt.target;
      do {
        if (targetElement === flyoutElement) {
          return;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);
      this.is_show = false;
    });

    if (this.initialText !== '') {
      this.is_show = false;
      this.text = this.initialText;
    }
  },
  methods: {
    onFocus: function () {
      if (this.initialText !== '' && !this.is_read_initial_tex) {
        this.is_read_initial_tex = true;
        return;
      }
      this.is_show = true;
    },
    onSelectItem (dato) {
      this.is_show = false;
      this.text = dato.contactName;
      this.$emit('itemselected', dato);
    },
    writeup () {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.doneTyping, this.doneTypingInterval);
    },
    writedown () {
      clearTimeout(this.typingTimer);
    },
    doneTyping () {
      this.$emit('search', this.text)
    }
  },
  watch: {
    text (val) {
      if (!this.is_read_initial_tex) {
        this.is_read_initial_tex = true;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
.content-input {
  width: 100%;
  position: relative;


  .ui-autocomplete {
    border-color: #e0e0e0;
    box-shadow: 0 1px 6px -1px rgba(64, 64, 64, 0.4);
    position: absolute;
    z-index: 1000;
    top: 33px;
    left: 0;
    right: 0;
    padding: 0;
    list-style-type: none;
    border-width: 1px;
    border-style: solid;
    border-top: 0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background: #fff;
    display: none;

    font-family: inherit;
    line-height: 1.6;
    margin: 0;
    list-style-position: outside;

    .show-result {
      max-height: 300px;
      overflow: hidden;
      overflow-y: scroll;
    }
    &.active {
      display: block;
    }
    .ui-menu-item {
      border-bottom-color: #dfe5f0;
      display: block;
      overflow: auto;
      font-size: 13px;
      padding: 0;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      &.item-found {
        &:hover {
          cursor: pointer;
          background-color: #e4eaf5;
        }
      }
      .ui-item-result {
        .info-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .name {
            display: block;
            font-size: 14px;
            margin-bottom: 4px;
          }
          .info-group {
            .email {
              max-width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .phone,
            .email,
            .age-group,
            .address,
            .membership {
              color: #7e7e7e;
              display: block;
              font-size: 12px;
            }
            &.info-end {
              display: flex;
              flex-wrap: wrap;
              flex-direction: column;
              align-self: flex-end;
            }
          }
        }
      }
      .person {
        padding-left: 0;
        margin-left: 8px;
        overflow: auto;
      }
      a {
        line-height: 1.35;
        position: relative;
        display: block;
        padding: 0.6em 0.75em;
        text-decoration: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// OnSiteContactSearch.vue?66d5836f